// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={82}
    height={80}
    viewBox="0 0 82 80"
    {...props}
  >
    <path
      d="M23.7311 15.2458C24.7942 15.2458 25.6403 15.4983 26.5341 16.4383L39.9361 30.5175H18.6905C17.3367 30.5175 16.0384 29.9928 15.0811 29.0589C14.1239 28.125 13.5861 26.8584 13.5861 25.5376H11.6192C10.2663 25.5376 8.96882 25.0134 8.01199 24.0803C7.05517 23.1472 6.51737 21.8815 6.51684 20.5616V20.3946H5.72053C5.05031 20.3948 4.3866 20.2663 3.76732 20.0162C3.14804 19.7662 2.58533 19.3996 2.11132 18.9373C1.63731 18.475 1.26129 17.9262 1.00475 17.3221C0.748204 16.718 0.616165 16.0705 0.616165 15.4167V15.2496L23.7311 15.2458Z"
      fill="#FCFBF7"
      stroke="#29292F"
      strokeWidth={0.9}
      strokeMiterlimit={10}
    />
    <path
      d="M6.51749 20.3906H23.2719"
      stroke="#29292F"
      strokeWidth={0.9}
      strokeMiterlimit={10}
    />
    <path
      d="M27.4652 25.5376H13.5855"
      stroke="#29292F"
      strokeWidth={0.9}
      strokeMiterlimit={10}
    />
    <path
      d="M58.2707 15.2458C57.2076 15.2458 56.3615 15.4983 55.4677 16.4383L42.0677 30.5175H63.3133C63.9835 30.5175 64.6472 30.3887 65.2664 30.1384C65.8856 29.8881 66.4481 29.5212 66.9219 29.0588C67.3958 28.5963 67.7716 28.0473 68.0279 27.4432C68.2842 26.839 68.416 26.1915 68.4157 25.5376H70.3826C71.7363 25.5376 73.0347 25.0129 73.9919 24.079C74.9492 23.1451 75.4869 21.8785 75.4869 20.5577V20.3907H76.2833C77.6365 20.3907 78.9343 19.8662 79.8912 18.9327C80.8481 17.9991 81.3856 16.733 81.3856 15.4128V15.2458H58.2707Z"
      fill="#FCFBF7"
      stroke="#29292F"
      strokeWidth={0.9}
      strokeMiterlimit={10}
    />
    <path
      d="M75.494 20.3906H58.7395"
      stroke="#29292F"
      strokeWidth={0.9}
      strokeMiterlimit={10}
    />
    <path
      d="M54.5443 25.5376H68.4241"
      stroke="#29292F"
      strokeWidth={0.9}
      strokeMiterlimit={10}
    />
    <path
      d="M40.8967 10.3998L6.15157 69.7212H75.6418L40.8967 10.3998Z"
      fill="#FF73A9"
      stroke="#29292F"
      strokeWidth={0.9}
      strokeMiterlimit={10}
    />
    <path
      d="M43.8908 31.1333H37.9025V52.6454H43.8908V31.1333Z"
      fill="#FCFBF7"
    />
    <path
      d="M44.0096 58.6838C44.0096 59.4894 43.6816 60.2621 43.0977 60.8317C42.5137 61.4014 41.7218 61.7214 40.896 61.7214C40.0702 61.7214 39.2783 61.4014 38.6944 60.8317C38.1105 60.2621 37.7824 59.4894 37.7824 58.6838C37.7824 57.8782 38.1105 57.1055 38.6944 56.5359C39.2783 55.9662 40.0702 55.6461 40.896 55.6461C41.7218 55.6461 42.5137 55.9662 43.0977 56.5359C43.6816 57.1055 44.0096 57.8782 44.0096 58.6838"
      fill="#FCFBF7"
    />
  </svg>
);
const SvgWarningWings = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgWarningWings;
